(function () {
  const dock = document.querySelector('[data-dock]');
  if (!dock) return;

  const trigger = dock.querySelector('[data-search-trigger]');
  const panel = dock.querySelector('[data-dock-search-panel]');
  const input = panel?.querySelector('.dock-search-input');
  const results = panel?.querySelector('.dock-search-results');
  const statusEl = panel?.querySelector('.dock-search-status');
  const closeBtn = panel?.querySelector('.dock-search-close');
  const viewAll = panel?.querySelector('.dock-search-viewall');

  const menuPanel = dock.querySelector('[data-dock-panel]');

  if (!trigger || !panel || !input || !results || !statusEl || !closeBtn || !viewAll) return;

  let abortCtrl = null;
  let lastQuery = '';

  function open() {
    // Fecha painel do menu (hover)
    if (menuPanel) {
      menuPanel.classList.remove('is-open');
      menuPanel.setAttribute('aria-hidden', 'true');

      dock.querySelectorAll('[data-dock-item]').forEach(btn => {
        btn.classList.remove('is-active');
        btn.setAttribute('aria-expanded', 'false');
      });
    }

    panel.classList.add('is-open');
    panel.setAttribute('aria-hidden', 'false');
    trigger.setAttribute('aria-expanded', 'true');
    setTimeout(() => input.focus(), 0);
  }

  function close() {
    panel.classList.remove('is-open');
    panel.setAttribute('aria-hidden', 'true');
    trigger.setAttribute('aria-expanded', 'false');
  }

  // CLICK ONLY
  trigger.addEventListener('click', (e) => {
    e.preventDefault();
    panel.classList.contains('is-open') ? close() : open();
  });

  closeBtn.addEventListener('click', close);

  // ESC fecha
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') close();
  });

  // Clique fora fecha
  document.addEventListener('click', (e) => {
    if (!panel.classList.contains('is-open')) return;
    if (!panel.contains(e.target) && !trigger.contains(e.target)) close();
  });

  function debounce(fn, delay) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn(...args), delay);
    };
  }

  function escapeHtml(str) {
    return String(str || '')
      .replaceAll('&', '&amp;')
      .replaceAll('<', '&lt;')
      .replaceAll('>', '&gt;')
      .replaceAll('"', '&quot;')
      .replaceAll("'", '&#039;');
  }

  function render(products) {
    results.innerHTML = products.map(p => {
      const img = p.image || '';
      const sub = [p.vendor, p.product_type].filter(Boolean).join(' / ');
      return `
        <a class="dock-result-card" href="${p.url}" role="listitem">
          <div class="dock-result-img">${img ? `<img src="${img}" alt="">` : ''}</div>
          <div class="dock-result-info">
            <div class="dock-result-title">${escapeHtml(p.title)}</div>
            <div class="dock-result-sub">${escapeHtml(sub)}</div>
          </div>
        </a>
      `;
    }).join('');
  }

  async function search(q) {
    const query = q.trim();
    lastQuery = query;

    if (!query) {
      statusEl.textContent = '';
      results.innerHTML = '';
      viewAll.href = '/search';
      return;
    }

    statusEl.textContent = 'Searching…';
    viewAll.href = `/search?q=${encodeURIComponent(query)}`;

    if (abortCtrl) abortCtrl.abort();
    abortCtrl = new AbortController();

    const url =
      `/search/suggest.json?q=${encodeURIComponent(query)}` +
      `&resources[type]=product&resources[limit]=8&resources[options][unavailable_products]=last`;

    const res = await fetch(url, { signal: abortCtrl.signal });
    const data = await res.json();

    const products = data?.resources?.results?.products || [];

    if (query !== lastQuery) return;

    if (!products.length) {
      statusEl.textContent = `No results for: ${query}`;
      results.innerHTML = '';
      return;
    }

    statusEl.textContent = `Results for: ${query}`;
    render(products);
  }

  input.addEventListener('input', debounce((e) => search(e.target.value), 180));
})();